import axios from "./helperComponents/axios";

//auth
export const login = (data) =>
  axios({
    method: "post",
    baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
    url: `/admin-login`,
    data: data,
  });

//job
export const getJobs = (page) =>
  axios({
    method: "get",
    url: `/jobs`,
    params: {
      page,
    },
  });
export const viewJob = (id) =>
  axios({
    method: "get",
    url: `/jobs/${id}`,
  });
export const createJob = (data) =>
  axios({
    method: "post",
    url: `/jobs`,
    data,
  });
export const editJob = (id, data) =>
  axios({
    method: "put",
    url: `/jobs/${id}`,
    data,
  });
export const changeJobStatus = (id, data) =>
  axios({
    method: "post",
    url: `/jobs/${id}/change-status`,
    data,
  });
export const deleteJob = (id) =>
  axios({
    method: "delete",
    url: `/jobs/${id}`,
  });

export const getJobApplication = (id, page) =>
  axios({
    method: "get",
    url: `/job-applications/${id}/job`,
    params: {
      page,
    },
  });

//countries
export const getCountries = (page) =>
  axios({
    method: "get",
    url: `/countries`,
    params: {
      page,
    },
  });
export const createCountry = (data) =>
  axios({
    method: "post",
    url: `/countries`,
    data,
  });
export const editCountry = (id, data) =>
  axios({
    method: "put",
    url: `/countries/${id}`,
    data,
  });
export const deleteCountry = (id) =>
  axios({
    method: "delete",
    url: `/countries/${id}`,
  });

//settings
export const updateSettings = (id, data) =>
  axios({
    method: "put",
    url: `/setting/${id}`,
    data,
  });
export const getSettings = () =>
  axios({
    method: "get",
    url: `/setting`,
  });
export const deleteSettingsImage = (id) =>
  axios({
    method: "delete",
    url: `/website-images/${id}`,
  });

//partners
export const getPartners = (page) =>
  axios({
    method: "get",
    url: `/partners`,
    params: {
      page,
    },
  });
export const createPartner = (data) =>
  axios({
    method: "post",
    url: `/partners`,
    data,
  });
export const updatePartner = (id, data) =>
  axios({
    method: "put",
    url: `/partners/${id}`,
    data,
  });
export const deletePartner = (id) =>
  axios({
    method: "delete",
    url: `/partners/${id}`,
  });

// certificates
export const getCertificates = (page) =>
  axios({
    method: "get",
    url: `/certificates`,
    params: {
      page,
    },
  });
export const createCertificate = (data) =>
  axios({
    method: "post",
    url: `/certificates`,
    data,
  });
export const updateCertificate = (id, data) =>
  axios({
    method: "put",
    url: `/certificates/${id}`,
    data,
  });
export const deleteCertificate = (id) =>
  axios({
    method: "delete",
    url: `/certificates/${id}`,
  });

// news
export const getNews = (page) =>
  axios({
    method: "get",
    url: `/news`,
    params: {
      page,
    },
  });
export const createNews = (data) =>
  axios({
    method: "post",
    url: `/news`,
    data,
  });
export const updateNews = (id, data) =>
  axios({
    method: "put",
    url: `/news/${id}`,
    data,
  });
export const deleteNews = (id) =>
  axios({
    method: "delete",
    url: `/news/${id}`,
  });
export const deleteNewsImage = (id) =>
  axios({
    method: "delete",
    url: `/news-images/${id}`,
  });
export const makeMainNews = (id, data) =>
  axios({
    method: "post",
    url: `/news/${id}/make-main-news`,
    data,
  });

// projects
export const getProjects = (page) =>
  axios({
    method: "get",
    url: `/projects`,
    params: {
      page,
    },
  });
export const createProject = (data) =>
  axios({
    method: "post",
    url: `/projects`,
    data,
  });
export const updateProject = (id, data) =>
  axios({
    method: "put",
    url: `/projects/${id}`,
    data,
  });
export const deleteProject = (id) =>
  axios({
    method: "delete",
    url: `/projects/${id}`,
  });
export const deleteProjectImage = (id) =>
  axios({
    method: "delete",
    url: `/project-images/${id}`,
  });
export const makeMainProject = (id, data) =>
  axios({
    method: "post",
    url: `/projects/${id}/make-main-projects`,
    data,
  });

// branches
export const getBranches = (page) =>
  axios({
    method: "get",
    url: `/branches`,
    params: {
      page,
    },
  });
export const createBranch = (data) =>
  axios({
    method: "post",
    url: `/branches`,
    data,
  });
export const updateBranch = (id, data) =>
  axios({
    method: "put",
    url: `/branches/${id}`,
    data,
  });
export const deleteBranch = (id) =>
  axios({
    method: "delete",
    url: `/branches/${id}`,
  });

// permissions
export const getPermissions = () =>
  axios({
    method: "get",
    url: `/permissions`,
  });
// admins
export const getAdmins = (page) =>
  axios({
    method: "get",
    url: `/admins`,
    params: {
      page,
    },
  });
export const createAdmin = (data) =>
  axios({
    method: "post",
    url: `/admins`,
    data,
  });
export const editAdmin = (id, data) =>
  axios({
    method: "put",
    url: `/admins/${id}`,
    data,
  });
export const deleteAdmin = (id) =>
  axios({
    method: "delete",
    url: `/admins/${id}`,
  });
// roles
export const getRoles = (page) =>
  axios({
    method: "get",
    url: `/roles`,
    params: {
      page,
    },
  });
export const showRole = (id) =>
  axios({
    method: "get",
    url: `/roles/${id}`,
  });
export const createRole = (data) =>
  axios({
    method: "post",
    url: `/roles`,
    data,
  });
export const editRole = (id, data) =>
  axios({
    method: "put",
    url: `/roles/${id}`,
    data,
  });
export const deleteRole = (id) =>
  axios({
    method: "delete",
    url: `/roles/${id}`,
  });
